import { Component, OnInit } from '@angular/core';
import { DialogRef } from '../../services/modal.service';
import { CommonModule } from '@angular/common';

export class ExportConfirmDialogContext {
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
}

@Component({
  standalone: true,
  selector: 'export-confirm-modal',
  templateUrl: './export-confirm-modal.component.html',

  imports: [CommonModule],
})
export class ExportConfirmDialogComponent implements OnInit {
  context: ExportConfirmDialogContext;

  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;

  constructor(public dialog: DialogRef<ExportConfirmDialogContext>) {
    this.context = dialog.context;
  }

  ngOnInit() {
    this.title = (this.context && this.context.title) || 'Confirmer le téléchargement';
    this.message = (this.context && this.context.message) || 'Êtes-vous sûr de vouloir télécharger ce fichier ?';
    this.confirmLabel = (this.context && this.context.confirmLabel) || 'Télécharger';
    this.cancelLabel = (this.context && this.context.cancelLabel) || 'Annuler';
  }

  confirm() {
    this.dialog.close(true);
  }
  cancel() {
    this.dialog.dismiss();
  }
}
